import { useQuery } from '@tanstack/react-query';
import { compensationService } from '@/services/compensation/compensationService';
import { compensationKeys } from './queryKeys';

export const useCompanyCompensationRules = () => {
  return useQuery({
    queryKey: [...compensationKeys.all, 'company-rules'],
    queryFn: () => compensationService.getCompanyCompensationRules(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: (failureCount, error) => {
      // Don't retry on authentication errors
      if (error.message.includes('JWT') || error.message.includes('Unauthorized')) {
        return false;
      }
      return failureCount < 3;
    },
  });
};